import React, { Fragment } from "react";
import { List, Datagrid, TextField , CardActions , CreateButton,ImageField ,
    Show ,SimpleShowLayout,BooleanField,ReferenceField, RichTextField} from 'react-admin';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';
import {Route} from 'react-router';
import MenuSurveyCreate from './MenuSurveyCreate';
import MenuSurveyEdit from './MenuSurveyEdit';
import {Drawer} from '@material-ui/core' ;
import {MenuSurveyUser} from './MenuSurveyUser';
import { makeStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
const MenuSurveyListActions =({basePath}) => (
    <CardActions>
        <CreateButton basePath={basePath} />
    </CardActions>
)

const useStyles = makeStyles({
    on: { color: 'blue' },
    off: { color: 'red' },
});

const ColoredTextField = props => {
    const classes = useStyles();
    return (
        <TextField
            className={classnames({
                [classes.on]: props.record[props.source] == 1,
                [classes.off]: props.record[props.source] == 0,
            })}
            {...props}
        />
    );
};
// Ensure the original component defaultProps are still applied as they may be used by its parents (such as the `Show` component):
ColoredTextField.defaultProps = TextField.defaultProps;

class MenuSurveyList extends React.Component {
    render () {

        const Stats = ({ record }) => {
            if (!record) return ;
            console.log(record);
            if (record.status == 1) {
                
                return <div style={{color: 'blue'}}>활성화</div>;
            }
            else if (record.status == 0)
            {
                return <div style={{color: 'red'}}>비활성화</div>;
            }
            else {
                return <div />;
            }
        }
        const props = this.props;
        
        return (
            <Fragment>
                <List {...props} actions={<MenuSurveyListActions />} perPage={25}>
                <Datagrid rowClick="edit" expand={<MenuSurveyUser />}>
                
                    <BooleanField source="published" label="개제" />

                    <ReferenceField  source="menuFile" label="섬네일 이미지"  reference="uploadedFiles" >
                        <ImageField   source="fullPath"/>
                    </ReferenceField>
                    <TextField source="menuName" label="메뉴명" />
                    <Stats label="현재상태" />
                    <TextField source="likeCount" label="총 좋아요 수" /> 
                    <TextField source="startDate" label="시작일" />
                    <TextField source="endDate" label="종료일" />
                    
                </Datagrid>
                </List>
                <Route path="/menusurveys/create">
                {({ match }) => (
                    <Drawer open={!!match} anchor="right" onClose={this.handleClose}>
                    <MenuSurveyCreate onCancel={this.handleClose} {...props} />
                    </Drawer>
                )}
                </Route>
                <Route path="/menusurveys/:id">
                {({ match }) => {
                    const isMatch = match && match.params && match.params.id !== "create";

                    return (
                    <Drawer open={isMatch} anchor="right" onClose={this.handleClose}>
                        {/* To avoid any errors if the route does not match, we don't render at all the component in this case */}
                        {isMatch ? (
                        <MenuSurveyEdit
                            id={match.params.id}
                            onCancel={this.handleClose}
                            {...props}
                        />
                        ) : null}
                    </Drawer>
                    );
                }}
                </Route>
            </Fragment>
        );
    }

handleClose = () => {
    this.props.push("/menusurveys");
};
}

export default connect (
    undefined,
    {push}
) (MenuSurveyList) ;